import {Component, Input, OnInit} from '@angular/core';
import {ExgModalService} from 'exc-controls-v2';
import {ExcRestService} from 'exc-rest-v2';
import {ExcTranslation} from 'exc-core-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ExcSecurityService} from 'exc-security-v2';

@Component({
  selector: 'app-modal-new-task-worklist',
  templateUrl: './modal-new-task-worklist.component.html',
  styles: [
  ]
})
export class ModalNewTaskWorklistComponent extends ExcTranslation implements OnInit {
  @Input() data: {worklistData: any, taskID?: string, auID?: string} = {worklistData: {}};
  uiModel: any = {
    apiBezeichnung: '',
    api_oid: '',
    apiSequence: undefined,
    apiFreigabe: 0,
    apiPruefen: 0,
    apiMonitoring: 0,
    apiSollDatum: undefined,
    apiPlanDatum: undefined,
    apiIstDatum: undefined,
    apiKommentar: '',
    apiSollDatumLCT: ''
  };
  uiModelDates: any = {
    apiPlanDatum: undefined,
    apiPlanDatumDate: undefined,
    apiPlanDatumTime: undefined,

    apiIstDatum: undefined,
    apiIstDatumDate: undefined,
    apiIstDatumTime: undefined,
  };

  constructor(public excRestService: ExcRestService,
              public modal: ExgModalService,
              public enumSvc: EnumerationService,
              public excSecurityService: ExcSecurityService) {
    super();
  }

  ngOnInit(): void {
    this.uiModel.api_oid = this.data.taskID ? this.data.taskID : this.data.auID;
  }

  clickedSave(): void {
    const SELF = this;

    if (this.uiModel.apiSollDatum && this.uiModel.apiBezeichnung.length !== 0) {
      if (this.data.worklistData.length > 0) {
        if (this.uiModel.apiSequence >= 0) {
          this.uiModel.apiSequence = this.data.worklistData[this.uiModel.apiSequence].apiSequence;
        } else {
          this.uiModel.apiSequence = this.data.worklistData.length + 1;
        }
      } else {
        this.uiModel.apiSequence = 1;
      }
      SELF.excRestService
        .post(SELF.excRestService.computeUrl('ScheduleItemC'), SELF.uiModel)
        .subscribe((response: any) => {
          if (response.rtval) {
            this.modal.showToast(SELF.getRessource('Success'), 'md-toast', 'fas fa-check-circle');
            this.modal.action(true);
          } else {
            this.modal.showToast(SELF.getRessource('Fail'), 'md-toast', 'fas fa-exclamation');
          }
        });
    }
  }

  combineDateTime(dateTyp: string, dateValue: any, timeValue: any = '00:00'): void {
    if (dateValue) {
      const date: Date = new Date(dateValue + 'T' + timeValue);
      const offset = date.getTimezoneOffset() / 60;

      const offsetSign = offset < 0 ? '+' : '-';
      const offsetHours = ('0' + Math.abs(offset)).slice(-2);


      this.uiModel[dateTyp] = date.toISOString().slice(0, -1) + offsetSign + offsetHours + ':00';
      this.uiModelDates[dateTyp + 'Date'] = dateValue;
      this.uiModelDates[dateTyp + 'Time'] = timeValue;
    }
  }


  clickedCancel(): void {
    const SELF = this;
    SELF.modal.close();
  }
}
